'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');
var apolloCacheInmemory = require('apollo-cache-inmemory');
var ApolloClient = _interopDefault(require('apollo-client'));
var apolloLinkRetry = require('apollo-link-retry');
var apolloLinkBatchHttp = require('apollo-link-batch-http');
var apolloLinkHttp = require('apollo-link-http');
var apolloLink = require('apollo-link');
var gql = _interopDefault(require('graphql-tag'));

var _templateObject;
var MAX_RETRY_ATTEMPTS = process.env.DEBUG ? 1 : 5;
var MAX_BATCH = process.env.DEBUG ? 1 : 10; // 10 is what Apollo uses for the default
// The amount of time to wait to invalidate the cache.

var CACHE_TTL_MINS = 30; // How fast to check if the cache is due for invalidation.

var CACHE_TTL_CHECK_MS = 1000;
var query = gql(_templateObject || (_templateObject = _rollupPluginBabelHelpers.taggedTemplateLiteral(["\n  {\n    cacheTtl @client\n  }\n"])));
var apolloClientFactory = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref.name,
      connectToDevTools = _ref.connectToDevTools,
      uri = _ref.uri,
      _ref$maxRetryAttempts = _ref.maxRetryAttempts,
      maxRetryAttempts = _ref$maxRetryAttempts === void 0 ? MAX_RETRY_ATTEMPTS : _ref$maxRetryAttempts,
      _ref$maxBatch = _ref.maxBatch,
      maxBatch = _ref$maxBatch === void 0 ? MAX_BATCH : _ref$maxBatch,
      batchInterval = _ref.batchInterval,
      cacheParam = _ref.cache,
      _ref$cacheTtlMins = _ref.cacheTtlMins,
      cacheTtlMins = _ref$cacheTtlMins === void 0 ? CACHE_TTL_MINS : _ref$cacheTtlMins,
      _ref$cacheTtlCheckMs = _ref.cacheTtlCheckMs,
      cacheTtlCheckMs = _ref$cacheTtlCheckMs === void 0 ? CACHE_TTL_CHECK_MS : _ref$cacheTtlCheckMs,
      _ref$restLinks = _ref.restLinks,
      restLinks = _ref$restLinks === void 0 ? {} : _ref$restLinks,
      fetch = _ref.fetch,
      _ref$ssrMode = _ref.ssrMode,
      ssrMode = _ref$ssrMode === void 0 ? false : _ref$ssrMode,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? function (_ref2) {
    var inFlight = _ref2.inFlight,
        rest = _ref2.rest,
        retry = _ref2.retry,
        batch = _ref2.batch;
    return apolloLink.from([inFlight, rest, retry, batch]);
  } : _ref$link,
      initialState = _ref.initialState,
      _ref$addTypename = _ref.addTypename,
      addTypename = _ref$addTypename === void 0 ? false : _ref$addTypename,
      fragmentMatcher = _ref.fragmentMatcher,
      persistor = _ref.persistor;

  var cache;

  if (cacheParam) {
    cache = cacheParam;
  } else {
    cache = new apolloCacheInmemory.InMemoryCache({
      addTypename: addTypename,
      fragmentMatcher: fragmentMatcher
    });

    if (initialState) {
      cache = cache.restore(initialState);
    }
  }

  var inFlightOperations = new Set();
  var inFlight = new apolloLink.ApolloLink(function (operation, forward) {
    inFlightOperations.add(operation);
    var observable = forward(operation);
    observable.subscribe({
      complete: function complete() {
        inFlightOperations.delete(operation);
      }
    });
    return observable;
  });
  var httpLink = maxBatch > 1 ? new apolloLinkBatchHttp.BatchHttpLink({
    uri: uri,
    fetch: fetch,
    batchMax: maxBatch,
    batchInterval: batchInterval
  }) : apolloLinkHttp.createHttpLink({
    uri: uri,
    fetch: fetch,
    useGETForQueries: true
  });
  var client = new ApolloClient({
    name: name,
    connectToDevTools: connectToDevTools,
    queryDeduplication: true,
    cache: cache,
    link: link({
      inFlight: inFlight,
      retry: new apolloLinkRetry.RetryLink({
        attempts: {
          max: maxRetryAttempts
        }
      }),
      // the key "batch" is part of an existing interface, so do not change it
      // however, it is safe to place either an HttpLink or HttpBatchLink here
      batch: httpLink,
      rest: new apolloLink.ApolloLink(function (operation, forward) {
        var restLink = restLinks[operation.operationName];
        if (restLink) return restLink.request(operation, forward);
        if (forward) return forward(operation);
        return null;
      })
    }),
    ssrMode: ssrMode
  });

  var createCacheTtl = function createCacheTtl() {
    var now = new Date();
    now.setTime(now.getTime() + cacheTtlMins * 60 * 1000);
    client.writeQuery({
      query: query,
      data: {
        cacheTtl: now.toISOString()
      }
    });
  };

  var checkCacheTtl = /*#__PURE__*/function () {
    var _ref3 = _rollupPluginBabelHelpers.asyncToGenerator( /*#__PURE__*/_rollupPluginBabelHelpers.regeneratorRuntime().mark(function _callee3() {
      var _ref4, cacheTtl, CacheClearStatus, tryToClearCache, interval;

      return _rollupPluginBabelHelpers.regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref4 = function () {
                try {
                  return client.readQuery({
                    query: query
                  }) || {};
                } catch (err) {
                  return {};
                }
              }(), cacheTtl = _ref4.cacheTtl;

              if (!(typeof cacheTtl !== 'string' || Number.isNaN(new Date(cacheTtl).getTime()))) {
                _context3.next = 4;
                break;
              }

              createCacheTtl();
              return _context3.abrupt("return");

            case 4:
              if (!(new Date(cacheTtl).getTime() - new Date().getTime() <= 0)) {
                _context3.next = 14;
                break;
              }

              (function (CacheClearStatus) {
                CacheClearStatus[CacheClearStatus["WAITING_FOR_IN_FLIGHT_OPERATIONS"] = 0] = "WAITING_FOR_IN_FLIGHT_OPERATIONS";
                CacheClearStatus[CacheClearStatus["CACHE_CLEARED"] = 1] = "CACHE_CLEARED";
              })(CacheClearStatus || (CacheClearStatus = {}));

              tryToClearCache = /*#__PURE__*/function () {
                var _ref5 = _rollupPluginBabelHelpers.asyncToGenerator( /*#__PURE__*/_rollupPluginBabelHelpers.regeneratorRuntime().mark(function _callee() {
                  return _rollupPluginBabelHelpers.regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(inFlightOperations.size > 0)) {
                            _context.next = 2;
                            break;
                          }

                          return _context.abrupt("return", CacheClearStatus.WAITING_FOR_IN_FLIGHT_OPERATIONS);

                        case 2:
                          _context.next = 4;
                          return client.resetStore();

                        case 4:
                          if (!persistor) {
                            _context.next = 7;
                            break;
                          }

                          _context.next = 7;
                          return persistor.purge();

                        case 7:
                          createCacheTtl();
                          return _context.abrupt("return", CacheClearStatus.CACHE_CLEARED);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function tryToClearCache() {
                  return _ref5.apply(this, arguments);
                };
              }();

              _context3.next = 9;
              return tryToClearCache();

            case 9:
              _context3.t0 = _context3.sent;
              _context3.t1 = CacheClearStatus.CACHE_CLEARED;

              if (!(_context3.t0 === _context3.t1)) {
                _context3.next = 13;
                break;
              }

              return _context3.abrupt("return");

            case 13:
              interval = setInterval( /*#__PURE__*/_rollupPluginBabelHelpers.asyncToGenerator( /*#__PURE__*/_rollupPluginBabelHelpers.regeneratorRuntime().mark(function _callee2() {
                return _rollupPluginBabelHelpers.regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return tryToClearCache();

                      case 2:
                        _context2.t0 = _context2.sent;
                        _context2.t1 = CacheClearStatus.CACHE_CLEARED;

                        if (!(_context2.t0 === _context2.t1)) {
                          _context2.next = 6;
                          break;
                        }

                        clearInterval(interval);

                      case 6:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })), 200);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function checkCacheTtl() {
      return _ref3.apply(this, arguments);
    };
  }();

  var cacheTtlTimeout = setTimeout(function () {
    return undefined;
  }, 0);

  var startCacheTtlChecker = function startCacheTtlChecker() {
    cacheTtlTimeout = setTimeout( /*#__PURE__*/_rollupPluginBabelHelpers.asyncToGenerator( /*#__PURE__*/_rollupPluginBabelHelpers.regeneratorRuntime().mark(function _callee4() {
      return _rollupPluginBabelHelpers.regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return checkCacheTtl();

            case 2:
              startCacheTtlChecker();

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })), cacheTtlCheckMs);
  };

  var stopCacheTtlChecker = function stopCacheTtlChecker() {
    clearTimeout(cacheTtlTimeout);
  };

  return {
    client: client,
    checkCacheTtl: checkCacheTtl,
    startCacheTtlChecker: startCacheTtlChecker,
    stopCacheTtlChecker: stopCacheTtlChecker,
    persistor: persistor
  };
});

exports.CACHE_TTL_CHECK_MS = CACHE_TTL_CHECK_MS;
exports.CACHE_TTL_MINS = CACHE_TTL_MINS;
exports.MAX_BATCH = MAX_BATCH;
exports.MAX_RETRY_ATTEMPTS = MAX_RETRY_ATTEMPTS;
exports.default = apolloClientFactory;
//# sourceMappingURL=apolloClientFactory.js.map
